import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";

// Externals
import classNames from "classnames";
import PropTypes from "prop-types";

import { connect } from "react-redux";

// Material helpers
import { withStyles, Collapse } from "@material-ui/core";

// Material components
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";

// Material icons
import * as Muicon from "@material-ui/icons";

// Component styles
import styles from "./styles";
import "./sidebar.css";
import { getUserDisplayName } from "../../../../utils";

import { SIDEBAR_LINKS } from "../../../../constants";

const Icon = ({ name, ...rest }) => {
  const IconComponent = Muicon[name];
  return IconComponent ? <IconComponent {...rest} /> : null;
};

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
        isOpen: {}
      };
  }

  handleCollapseClick = (name) => {
    this.setState(prevState => ({...prevState, isOpen:{...prevState.isOpen, [name]:!this.state.isOpen[name]}}))
  }

  checkPathname() {
    var pathname = window.location.pathname;
    if (pathname === undefined) return false;
    if (pathname === "/manage-connections") return true;
    var string = pathname.substring(pathname.indexOf("/") + 1, pathname.lastIndexOf("/"));
    return string === "enabled-intents";
  }

  render() {
    const { classes, className, administrator, appType } = this.props;
    const { openSettings, isOpen } = this.state;
    const rootClassName = classNames(classes.root, className);
    this.checkPathname();

    return (
      <nav className={rootClassName}>

        <List component="div" disablePadding>

        {/* For adding new sidebar link, insert it into SIDEBAR_LINKS */}
        { SIDEBAR_LINKS.map(link => {

          //show/hide by the user
          if(!administrator&&link.disableForNonAdmin) return null;

          //show/hide by the app
          if(link.disabledAccessApps.includes(appType)) return null;

          if(link.subLinks){
            let openCollapse = link.subLinks.some(el => el.pathname === window.location.pathname);
            return(
              <React.Fragment key={link.name}>
                <ListItem key={link.name} className={classes.listItem} button onClick={() => this.handleCollapseClick(link.name)}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <Icon name={link.MuiIconName} />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.listItemText }} primary={link.name} />
                  {isOpen[link.name] || openCollapse ? (
                    <Icon name="ExpandLess" className={classes.listItemIcon} />
                  ) : (
                    <Icon name="ExpandMore" className={classes.listItemIcon} />
                  )}
                </ListItem>
                <Collapse in={isOpen[link.name] || openCollapse} timeout="auto" unmountOnExit>
                  {link.subLinks.map(subLink => {
                    return(
                    (!administrator&&subLink.disableForNonAdmin)?null:
                    <NavLink key={subLink.name} to={subLink.pathname} className={classes.navLink}>
                      <ListItem
                        className={ window.location.pathname === subLink.pathname?classes.activeListItem:classes.listItem }>
                        <ListItemIcon className={classes.listItemIcon}>
                          <Icon name={subLink.MuiIconName} />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.listItemText }} primary={subLink.name} />
                      </ListItem>
                    </NavLink>
                    )
                  })}
                </Collapse>
              </React.Fragment>
              )}
            return(
              <NavLink key={link.name} to={link.pathname} className={classes.navLink}>
                <ListItem className={window.location.pathname !== link.pathname ? classes.listItem : classes.activeListItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <Icon name={link.MuiIconName} />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.listItemText }} primary={link.name} />
                </ListItem>
              </NavLink>)
          })}
        </List>
      </nav>
    );
  }
}

Sidebar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  cognitoUser: PropTypes.object
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    administrator: _.get(state, "auth.cognitoUser.attributes.custom:role", "user") === "Administrator",
    appType: state.common.appType??null
  };
}

export default connect(mapStateToProps, null)(withStyles(styles)(Sidebar));
